import type { TFunction } from "i18next";

function catalogSlug(value: string): string {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

export function localizeMontageCatalog(
  name: string | null | undefined,
  description: string | null | undefined,
  t: TFunction,
): { name: string; description: string } {
  const rawName = String(name || "").trim();
  const rawDescription = String(description || "").trim();
  if (!rawName) {
    return {
      name: "",
      description:
        rawDescription ||
        t("presets.noDescription", { defaultValue: "No description provided" }),
    };
  }

  const key = catalogSlug(rawName);
  const localizedName = t(`presets.catalog.montages.${key}.name`, {
    defaultValue: rawName,
  });
  const localizedDescription = t(`presets.catalog.montages.${key}.description`, {
    defaultValue:
      rawDescription ||
      t("presets.noDescription", { defaultValue: "No description provided" }),
  });

  return { name: localizedName, description: localizedDescription };
}

export function localizePerspectiveCatalog(
  name: string | null | undefined,
  description: string | null | undefined,
  t: TFunction,
): { name: string; description: string } {
  const rawName = String(name || "").trim();
  const rawDescription = String(description || "").trim();
  if (!rawName) {
    return {
      name: "",
      description:
        rawDescription ||
        t("presets.noDescription", { defaultValue: "No description provided" }),
    };
  }

  const key = catalogSlug(rawName);
  const localizedName = t(`presets.catalog.perspectives.${key}.name`, {
    defaultValue: rawName,
  });
  const localizedDescription = t(
    `presets.catalog.perspectives.${key}.description`,
    {
      defaultValue:
        rawDescription ||
        t("presets.noDescription", { defaultValue: "No description provided" }),
    },
  );

  return { name: localizedName, description: localizedDescription };
}
